import React from 'react';
import styled from '@emotion/styled'

const SkillListWrapper = styled.ul`
    display: grid;
    gap: 25px;
    grid-template-columns: repeat(1, 1fr);
    @media screen and (min-width: 468px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }
    li {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        > div:nth-of-type(1) {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            min-width: 60px;
            aspect-ratio: 1/1;
            box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.05) inset;
            border-radius: 15px;
            img {
                display: block;
                max-width: 100%;
            }
        }
        h4 {
            font-weight: 700;
            color: var(--color-gray-600);
            line-height: calc(18.5/15);
        }
    }
`

const SkillList = ({arrSkill, additionalSkill}) => {
    
    return(
        <SkillListWrapper>
            {
                additionalSkill?
                <li>
                    <div>
                        <img src={additionalSkill.skill_icon} alt="" />
                    </div>
                    <div>
                        <h4>
                            {additionalSkill.skill_name}
                        </h4>
                        <p>
                            {additionalSkill.skill_level}
                        </p>
                    </div>
                </li>
                :null
            }
            {
                arrSkill.map(
                    (element, index)=>{
                        return <li key={index}>
                            <div>
                                <img src={element.skill_icon} alt="" />
                            </div>
                            <div>
                                <h4>
                                    {element.skill_name}
                                </h4>
                                <p>
                                    {element.skill_level}
                                </p>
                            </div>
                        </li>
                    }
                )
            }
            
        </SkillListWrapper>
    )
}

export default SkillList;